module.exports = __webpack_public_path__ + "static/media/mode-17.ed0a5a0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-17.svg
// module id = 990
// module chunks = 2